module.exports = __webpack_public_path__ + "img/mobiletodo.1ce30ee1.png";